import React from "react";
import { useMediaQuery } from "react-responsive";
import { VacacionesPageMovil, VacacionesPageWeb } from "./componentes";
import { Provider as JotaiProvider } from "jotai";
import { useValidarUrl } from "hooks";

const SolicitudAusenciaPage = () => {
	const esMovil = useMediaQuery({ query: "(max-width: 860px)" });
	const esDesktop = useMediaQuery({ query: "(min-width: 860px)" });

	const { } = useValidarUrl();

	return (
		<JotaiProvider>
			{esMovil && <VacacionesPageMovil />}
			{esDesktop && <VacacionesPageWeb />}
		</JotaiProvider>
	);
};

export default SolicitudAusenciaPage;
